import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";

import { fetchFAQs } from "@/api/fetchFAQs";

import CustomAccordion from "@/components/CustomAccordion";
import SearchBar from "../SearchBar";
import Section from "@/components/Section";
import { accordionStyles } from "./styles";

const FAQList = () => {
  const [FAQsData, setFAQsData] = useState<IFAQ[] | undefined>(undefined);
  const [searchParams] = useSearchParams();

  // Fetch data
  useEffect(() => {
    const fetchFAQList = async () => {
      const search = searchParams?.get("search") || "";
      const FAQdata = await fetchFAQs(search);
      setFAQsData(FAQdata);
    };

    fetchFAQList();
  }, [searchParams]);

  return (
    <Section
      pt={{ xs: 0, md: 2, lg: 7.5 }}
      pb={{ xs: 10, md: 14, lg: 25 }}
      heading="We’re here to help"
      subTitle="Need something cleared up? Here are our most frequently asked questions."
      titleSx={{ textAlign: { xs: "start", sm: "center" } }}
      subtitleSx={{ textAlign: { xs: "start", sm: "center" } }}
    >
      <SearchBar />

      <Box
        display="flex"
        flexDirection="column"
        gap={{ xs: 2, md: 4 }}
        maxWidth={970}
        mx={"auto"}
        sx={accordionStyles}
      >
        {FAQsData &&
          FAQsData.map((faq) => (
            <CustomAccordion
              key={faq.id}
              label={faq.title}
              type="secondary"
              icon={null}
            >
              <Box dangerouslySetInnerHTML={{ __html: faq.data }} />
            </CustomAccordion>
          ))}
      </Box>
    </Section>
  );
};

export default FAQList;
